<!-- 
 * @description: 西药预购药品和诊断
 * @author: 翠山 
 * @date: 2021-02-07 11:05:17 
 * @后台人员:  
!-->
<template>
    <div :class="['westernMedicine', { setHeight: showAdd }]"
         v-show="medicineType==0">
        <div class="buy-medicine"
             v-if="step == 1">
            <!-- 预购药品 -->
            <div class="content">
                <div :class="['search-box', { 'z-index_3000': filterFlag }]">
                    <form :class="isPad ? 'form-pad' : 'form'"
                          @submit.prevent="formSubmit"
                          action="javascript:return true">
                        <van-search v-model="searchVal"
                                    type="search"
                                    :class="isPad ? 'search-input-pad' : 'search-input'"
                                    @keydown="handleKeydown($event)"
                                    placeholder="请输入药品首拼或关键字搜索"
                                    shape="round"
                                    :clearable="false"
                                    @input="fetchData(searchVal)" />
                        <span v-if="!isPad"
                              class="search-btn"
                              @click="handClickLabel(searchVal, null, null)">搜索</span>
                    </form>
                    <span v-if="isPad"
                          class="search-btn-pad"
                          @click="handClickLabel(searchVal, null, null)">搜索</span>
                    <div class="qrcode"
                         v-if="!isPad"
                         @click="handleQrcode">
                        <i class="patient-icon-qrcode"></i>
                        <span>扫码加药</span>
                    </div>
                    <div class="search-tips-wrap">
                        <p class="search-tips">
                            可输入药品名称或首拼+空格+规格搜索 例:头孢 0.25g*10
                        </p>
                    </div>
                </div>
                <!--  -->
                <div class="hot-medicine"
                     v-if="searchVal.length === 0 && listData.length === 0 && !showNoData">
                    <p class="top-title"
                       v-show="hotList.length > 0">常用药品推荐</p>
                    <ul class="hot-medicine-list">
                        <li v-for="(item, index) in hotList"
                            :key="index">
                            <img :src="hotImgs[index]"
                                 class="hot-medicine-rank_img"
                                 alt />
                            <div class="hot-medicine-item van-hairline--bottom">
                                <p class="hot-medicine-item_top">
                                    <span v-if="parseInt(item.prescriptionYn) === 1"
                                          class="hot-medicine-item_rx">Rx</span>
                                    <span class="hot-medicine-item_name van-ellipsis">{{
                    item.commonName
                  }}</span>
                                </p>
                                <p class="hot-medicine-item_bottom van-ellipsis">
                                    {{ item.attributeSpecification }}
                                </p>
                                <p class="hot-medicine-item_producingArea van-ellipsis"
                                   v-if="item.drugChannel == 1">
                                    {{ item.manufacturer || '' }}
                                </p>
                                <span class="hot-medicine-item_add"
                                      @click="handleAddMedicineFromHot(item, index)">添加</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <!--快速搜索-->
                <div v-show="list.length > 0 && !isKeydown"
                     class="search-main">
                    <ul class="search-list">
                        <li v-for="(item, index) in list"
                            :key="index + 'list'"
                            @click="handClickLabel(item, index, 'secSearch')"
                            v-html="onReplaceFont(item, searchVal.split(' ')[0])"
                            style="font-size: 14px;"></li>
                    </ul>
                </div>
                <!--搜索结果列表-->
                <div class="nodata-wrap"
                     v-show="
                        (searchVal &&
                        !isShowLoading &&
                        list.length === 0 &&
                        listData.length === 0 &&
                        !isClickLabel) ||
                        showNoData
                    ">
                    <img src="@/icons/nodata.png"
                         alt />
                    <p>{{ noticeText }}</p>
                </div>
                <div class="search-end"
                     v-if="listData.length > 0">
                    <ul class="cart-goods">
                        <li v-for="(item, index) in listData"
                            :key="index"
                            class="goods van-hairline--bottom"
                            style=" display: flex; align-items: center;">
                            <div class="goods-left">
                                <div class="goods-name">
                                    <p class="goodsName"><span v-if="parseInt(item.prescriptionYn) === 1">Rx</span>{{ item.commonName }}</p>
                                </div>
                                <p class="specifications van-ellipsis">
                                    {{ item.attributeSpecification }}
                                </p>
                                <p class="producingArea van-ellipsis"
                                   v-if="item.drugChannel == 1">
                                    {{ item.manufacturer || '' }}
                                </p>
                            </div>
                            <button v-show="item.num == 0"
                                    type="button"
                                    class="add van-stepper__plus"
                                    name="add"
                                    @click="plus(item)" />
                            <van-stepper style="width: 115px;"
                                         v-show="item.num > 0"
                                         v-model="item.num"
                                         integer
                                         disable-input
                                         min="0"
                                         @minus="minus(item, index)"
                                         @plus="plus(item, index)" />
                            <span v-show="item.num > 0"
                                  class="usage_text">{{ item.unitName }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="bottom-bar">
                <div class="cart"
                     @click="showCart = !showCart">
                    药品列表
                    <span v-if="medicineArr.length > 0">{{
            medicineArr.length > 99 ? '99...' : medicineArr.length
          }}</span>
                </div>
                <van-button round
                            block
                            type="info"
                            :color="'#01B956'"
                            @click="stepPageDialog">确定</van-button>
            </div>
        </div>
        <van-popup v-model="showCart"
                   position="bottom"
                   :round="true">
            <div class="box">
                <div class="box-top">
                    <span class="box-title">预购药品</span>
                    <img src="@/icons/close.png"
                         alt
                         @click="showCart = false" />
                </div>
                <ul class="cart-goods">
                    <li v-for="(item, index) in medicineArr"
                        :key="index + item.productPref || index + item.pref"
                        class="goods van-hairline--bottom"
                        style="display: flex; align-items: center;">
                        <div class="goods-left">
                            <div class="goods-name">
                                <p class="goodsName">
                                    <span v-if="parseInt(item.prescriptionYn) === 1">Rx</span>
                                    {{ item.commonName ? item.commonName : item.productName }}
                                </p>
                            </div>
                            <p class="specifications van-ellipsis">
                                {{ item.attributeSpecification }}
                            </p>
                            <p class="producingArea van-ellipsis"
                               v-if="item.drugChannel == 1">
                                {{ item.manufacturer || '' }}
                            </p>
                        </div>
                        <van-stepper style="width: 115px;"
                                     :value="item.num"
                                     integer
                                     min="0"
                                     disable-input
                                     @minus="minus(item, index)"
                                     @plus="plus(item, index)" />
                        <span v-show="item.num > 0"
                              class="usage_text">{{ item.unitName }}</span>
                    </li>
                </ul>
                <van-button class="closeMedicinePup"
                            type="info"
                            size="large"
                            round
                            @click="closeMedicinePup">确定</van-button>
            </div>
        </van-popup>
        <!-- 提示用法用量弹窗 -->
        <van-popup v-model="showUsageDialog"
                   position="bottom"
                   :round="true">
            <div class="box">
                <div class="box-top">
                    <span class="box-title">Rp:</span>
                    <img src="@/icons/close.png"
                         alt
                         @click="showUsageDialog = false" />
                </div>
                <ul class="cart-goods cart-goods-two">
                    <li v-for="(item, index) in medicineArr"
                        :key="index + item.productPref || index + item.pref"
                        class="goods van-hairline--bottom"
                        style="display: flex; align-items: center">
                        <div class="goods-left">
                            <div class="goods-name">
                                <p class="goodsName">
                                    <span v-show="parseInt(item.prescriptionYn) === 1">处方药</span>
                                    {{ item.commonName ? item.commonName : item.productName }}
                                </p>
                            </div>
                            <p class="specifications van-ellipsis">
                                {{ item.attributeSpecification }}
                            </p>
                            <p class="producingArea van-ellipsis"
                               v-if="item.drugChannel == 1">
                                {{ item.manufacturer || '' }}
                            </p>
                            <p v-if="
                                item.directions &&
                                    (item.singleDose || item.singleUnit == '适量') &&
                                    item.singleUnit &&
                                    item.useFrequency
                                "
                               style=" font-size: 14px; color: rgba(102, 102, 102, 1);"
                               @click="stepCurrentDrugs(item)">
                                {{ buildUsageText(item) }}
                            </p>
                            <!-- &&usageAndDosageReviewSwitch&&!item.hasList -->
                            <p v-else-if="isShowUsage"
                               style=" font-size: 14px; color: #01B956;"
                               @click="stepCurrentDrugs(item)">
                                请补充用法用量
                            </p>
                        </div>
                        <!-- {{ item }} -->
                        <div>
                            <div style="font-size: 14px; margin-left: 64px;"
                                 @click="deleteCruttenDrugs(item,index)">
                                <van-image width="20px"
                                           height="20px"
                                           :src="require('@/icons/delete.png')" />
                            </div>
                            <div style="height: 20px;"></div>
                            <van-stepper style="width: 110px;"
                                         :value="item.num"
                                         integer
                                         disable-input
                                         :disable-minus="item.num == 1"
                                         @overlimit="overlimit"
                                         @minus="minus(item, index)"
                                         @plus="plus(item, index)" />
                        </div>
                        <span v-show="item.num > 0"
                              class="usage_text"
                              style=" font-size: 12px; text-wrap: nowrap;  margin-top: 50px; margin-left: 5px;">{{ item.unitName }}</span>
                    </li>
                </ul>
                <van-button round
                            block
                            type="info"
                            :color="'#01B956'"
                            @click="submitMedicine">确定</van-button>
            </div>
        </van-popup>
        <shoppingMessage ref="shop"
                         :new-list-data="newListData"
                         :usedrug-data="usedrugData"
                         :usedrug-data2="usedrugData2"
                         :unit-data="unitData"
                         :dosage-data="dosageData"
                         :method-data="methodData"
                         :message-showt="messageShow"
                         @closemessage="closemessage"
                         @submitChangeList="submitChangeList" />
        <LoadingComponent :is-show="isShowLoading" />
    </div>
</template>
<script>
import { getCookie } from '@/utils/auth'
import {
  queryMedicineList2,
  drugsList2,
  unitList,
  rateList,
  getMethod,
  getDose,
  updateMedicine,
  suggestMedicine,
  getMedicineByBarcode,
  queryDrugstorePackageInquiryType,
  getUsageAndDosageWriteSwitch,
  getMedicineByBarcodeNew,
  getInquiryAreaAndDrugstoreConfigSwitch,
  getPageConfigurationQueryRuleByDrug
} from '@/api/index'
import LoadingComponent from '@/components/Loading'
import shoppingMessage from "./shopping-message.vue";

const noticeTextArr = [
    '暂无搜索结果，请使用关键词搜索或【新增药品】', //扫码
    '暂无搜索结果，请调整关键词搜索或【新增药品】' //关键字
]
export default {
    props: ['step', 'medicineType', 'medicineArr','age'],
    data () {
        return {
            apiFlag:false, // 用来判断是否回显用法用量 ，每次调用接口只回显一次
            usedrugData2:[], // 某一项药品的频率
            usageAndDosageDrugRuleDetailDtoList:[], // 药品规则 根据规则来填写用法用量啥的
            usageAndDosageDrugRuleDetailDtoMap:{}, // 加入购物车的药品 和规则之间的对应关系
            usageAndDosageReviewSwitch:false, //用法用量审核开关
            submitDisabled: false, // 提交处方按钮,默认flase按钮可点
            isClickLabel: false,
            showCart: false, //显示药品清单
            showUsageDialog: false, // 用法用量弹层
            messageShow: false, // 用法用量弹层
            newListData: {}, // 当前修改药品
            showAdd: false, //显示新增
            filterFlag: false,
            isPad: false,
            searchVal: '',
            listData: [],
            showNoData: false,
            hotList: [], // top药品
            hotImgs: [
                require('../../../icons/hot1.png'),
                require('../../../icons/hot2.png'),
                require('../../../icons/hot3.png'),
                require('../../../icons/hot4.png'),
                require('../../../icons/hot5.png'),
                require('../../../icons/hot6.png'),
                require('../../../icons/hot7.png'),
                require('../../../icons/hot8.png'),
                require('../../../icons/hot9.png'),
                require('../../../icons/hot10.png')
            ],
            isShowLoading: false,
            list: [],
            noticeText: '',
            unitData: [],
            methodData: [],
            dosageData: [],
            usedrugData: [],
            isShowUsage: true,
            isEditUsage: true, // 是否允许编辑用法用量
        }
    },
    created () {
        this.getUsageAndDosageWriteSwitch();
        this.getInquiryAreaAndDrugstoreConfigSwitch();
        this.unitFun();
        this.methodFun();
        this.doseFun();
        this.rateListFun();
        this.getSuggestion()
        this.isPad = getCookie('native_client') === 'pad' ? true : false
        window.getQrCodeMsg = data => {
            console.error('扫码')
            //扫描二维码回调
            this.getMedicineByQrcode(data)
        }
        document.addEventListener('visibilitychange',()=>{
            console.log('监听页面返回----',document.hidden);
                setTimeout(() => {
                 console.log('监听页面返回time----',document.hidden);

                    window.location.href = 'protocol://action/hideBottomTab'
                }, 600);
        },false)
    },
    components: {
        LoadingComponent,
        shoppingMessage,
    },
    computed: {
        CartNum () {
            return this.medicineArr.length;
        },
    },
    watch: {
        CartNum (newValue, oldValue) {
            if (newValue < 1) {
                this.showUsageDialog = false;
            }
        },
        step (newValue, oldValue) {
            let prefs = this.medicineArr.map((e) => e.productPref ? 'productPref' : 'pref');
            if (this.medicineArr.length < 1) {
                this.listData.forEach((item) => {
                    item.num = 0
                })
            } else {
                this.listData.forEach((item) => {
                    if (!prefs.includes(item.pref)) {
                        item.num = 0
                    }
                })
            }
            this.handleData()
        },
    },
    methods: {
        processMap(){
            this.usageAndDosageDrugRuleDetailDtoMap = new WeakMap() ; 
            // 处理药品 对应是否有规则
            this.medicineArr.forEach((item,itemIndex) => {
                let index = this.usageAndDosageDrugRuleDetailDtoList.findIndex((e) => e.commonName == item.commonName&&e.specification == item.attributeSpecification);
                if (index != -1) { // 该药品有规则
                    let key = item.commonName + itemIndex + item.attributeSpecification;
                    let val = this.usageAndDosageDrugRuleDetailDtoList[index] ;
                    this.usageAndDosageDrugRuleDetailDtoMap.set(item,val)
                    item.hasList = true ;  // 该药品有规则
                }
            })
            this.showUsageDialog = true; // 显示用法用量弹窗

            // 处理是否使用 配置的规则用法用量
            this.medicineArr.forEach((item) => {
                if(!this.usageAndDosageReviewSwitch || !item.hasList ) return  ;
                let list = this.usageAndDosageDrugRuleDetailDtoMap.get(item) ; // 获取该药品的规则
                item.directions = list.directions

                debugger
                // 如果中台的 用量符合要求的话就不要审核返回的数据了
                if(!(item.singleDose && item.singleUnit == list.singleUnit &&  Number(item.singleDose) >= Number(list.minSingleDose) &&Number(item.singleDose)<=Number(list.maxSingleDose))) {
                  item.singleDose = list.minSingleDose;
                }
                
                // item.singleDose = list.minSingleDose
                item.singleUnit = list.singleUnit

                // 如果中台的 频次符合要求的话就不要审核返回的数据了
                if(!list.useFrequencyListList.includes(item.useFrequency) ) {
                  item.useFrequency = list.useFrequencyListList[0] ; 
                }
            })
        },
        async getPageConfigurationQueryRuleByDrug(){
            console.log(this.isShowUsage,this.usageAndDosageReviewSwitch) ;
            let usageAndDosageRuleDrugDetailQueryDtoList = this.medicineArr.map((e) => {
                return {
                    commonName: e.commonName,
                    specification: e.attributeSpecification,
                }
            })
            try {
                let res = await getPageConfigurationQueryRuleByDrug({age:this.age,usageAndDosageRuleDrugDetailQueryDtoList})
                if(res.data.code == 0) {
                    this.usageAndDosageDrugRuleDetailDtoList = res.data.result.usageAndDosageDrugRuleDetailDtoList || []
                    this.apiFlag = true ; 
                    this.processMap() ; 
                }
            } catch (error) {
                this.showUsageDialog = true;
            }
        },
        buildUsageText (item) {
            return `${item.directions},一次${item.singleUnit === '适量' ? "" : item.singleDose}${item.singleUnit},${item.useFrequency}`
        },
        submitChangeList (data) {
            console.log(data);
            this.medicineArr.forEach(item => {
                console.log('----bug');
                if (item.pref == data.productPref) {
                    console.log('----bug66666');
                    item.directions = data.directions || '';
                    item.useFrequency = data.useFrequency || '';
                    item.useFrequencyValue = data.useFrequencyValue || '';
                    item.singleDose = data.singleDose || '';
                    item.singleDoseValue = data.singleDoseValue || '';
                    item.singleUnit = data.singleUnit || '';
                    item.singleDoseZh = data.singleDoseZh || '';
                    item.singleUnitValue = data.singleUnitValue || '';
                    item.useFrequencyZh = data.useFrequencyZh || '';
                    item.num = data.quantity || '';
                }
            });
            console.log(this.medicineArr);
            this.handleData()
            // this.$forceUpdate()
        },
        deleteCruttenDrugs (item, index) {
            const sign = this.medicineArr.findIndex(el => {
                return el.pref === item.pref
            })
            this.medicineArr[sign].num = 0;
            this.minusReport(this.medicineArr[sign])
            this.$emit(
                'perfOfDeleteMedicine',
                this.medicineArr[sign].pref || this.medicineArr[sign].productPref
            )
            this.handleData()
            this.medicineArr.splice(sign, 1)
        },
        closemessage (data) {
            this.messageShow = false;
            this.showUsageDialog=true ; // 打开Rp弹框
        },
        stepCurrentDrugs (item) {
            this.usedrugData2 = [] ;
            item.useFrequencyZh = item.useFrequency
            console.log(this.usageAndDosageReviewSwitch,"--",this.isShowUsage,"---",item)
            if (this.usageAndDosageReviewSwitch&&!this.isShowUsage&&!item.hasList) return;
            var ee = JSON.stringify(item);
            this.newListData = JSON.parse(ee);
            let list = this.usageAndDosageDrugRuleDetailDtoMap.get(item) ; // 获取该药品的规则
            if(list) {
                let arr = [] ; 
                list.useFrequencyListList.forEach((item)=>{
                    let index = this.usedrugData.findIndex((item2)=>item == item2.name)
                    arr.push({
                        name:item,
                        value:this.usedrugData[index].value
                    })
                })
                if(this.apiFlag) {
                    this.apiFlag = false ; 
                    this.newListData.useFrequencyZh = item.useFrequency
                    this.newListData.singleDoseZh = item.singleDose
                    this.newListData.singleDose = item.singleDose
                    this.newListData.useFrequency = item.useFrequency
                    this.newListData.singleUnit = list.singleUnit
                }
                this.usedrugData2 = arr ;
                this.newListData.minSingleDose = list.minSingleDose
                this.newListData.maxSingleDose = list.maxSingleDose // 单次用量上下限
                this.newListData.hasShow = true ;
            }
            this.messageShow = true
        },
        /**
         * @description:点击添加商品（从猜你想要里添加）
         * @param: {Object} item 商品数据
         * @return: void
         */
        handleAddMedicineFromHot (item, index) {
            if (!item.num) {
                this.$set(item, 'num', 1)
            }
            //判断该药品是否被添加过
            const sign = this.medicineArr.findIndex(el => {
                return el.pref === item.pref
            })
            if (sign === -1) {
                if (this.medicineArr.length > 4) {
                    this.$toast({
                        message: '最多添加5种药品',
                        duration: 2000
                    })
                    this.showAdd = false
                    return false
                }
                this.addMedicine(item)
            } else {
                this.plus(this.medicineArr[sign])
            }
            this.$toast({
                message: '添加成功',
                type: 'success',
                duration: 800
            })
            window.webSdk.track('click_suggest_medicine', {
                organSign: getCookie('native_organSign'),
                productPrefs: item.pref,
                seq: index
            })
        },
        /**
         * @description:新增药品
         * @return: void
         */
        addMedicine (data) {
            if (this.medicineArr.length > 4) {
                this.$toast({
                    message: '最多添加5种药品',
                    duration: 2000
                })
                this.showAdd = false
                return false
            }
            data && this.medicineArr.push(data)
            this.showAdd = false
        },
        /**
         * @description:获取top药品
         * @return: void
         */
        async getSuggestion () {
            try {
                const params = {
                    organSign: getCookie('native_organSign')
                }
                const res = await suggestMedicine(params)
                if (res.code === 0) {
                    this.hotList = res.result.slice(0, 10)
                    let productPref = []
                    this.hotList.foreach(item => {
                        productPref.push(item.pref)
                    })
                    window.webSdk.track('suggest_medicines_expose', {
                        organSign: getCookie('native_organSign'),
                        productPref
                    })
                }
            } catch (err) {
                console.log(err.msg)
            }
        },
        closeMedicinePup () {
            this.showCart = false
        },
        /**
         * @description:根据条形码搜药
         * @param: {}
         * @param: {}
         * @return:
         */
        async getMedicineByQrcode (data) {
            // todo 69码
            // todo 69码
      const params = {
        barCode: data,
        organSign: getCookie('native_organSign')
      }
      this.isShowLoading = true
        window.location.href = 'protocol://action/hideBottomTab'
        console.log("window.location.href = 'protocol://action/hideBottomTab'")
      try {
        // todo 修改接口 getMedicineByBarcodeNew
                // todo 修改接口 getMedicineByBarcodeNew
                const res = await getMedicineByBarcodeNew(params)
                window.webSdk.track('ds_page_scan_res', {
                    organSign: getCookie('native_organSign'),
                    barCode: data,
                    num: (res.result && res.result.length) || 0,
                    pref: (res.result && res.result[0].pref) || 0
                })
                if (res.result.length) {
            this.$toast({
              message:'扫码药品添加成功',
              duration:500
            })
            console.error(res)
           let listData = res.result ;
            if(listData.length == 1 ) { // 如果只有一个商品走原流程
              let result = listData[0] ;
              const index = this.medicineArr.findIndex(item=>{
                  return item.pref === result.pref
              })
              if(index !== -1){ // 如果有了
                  this.listData = [result]
                  this.plus(this.medicineArr[index], 0)
                  this.handleData()
              }else{ // 如果没有
                this.$set(result, 'num', 0)
                this.$set(result, 'scanText', data)
                this.listData = [result]
                this.plus(result)
                this.handleData()
              }
          }else { // 多个药品的话 不会加入购物车 需要用户手动添加
            listData.map((e) => e.num = 0)
            this.listData = listData
              this.handleData()
          }
          // medicineArr  表示购物车列表   listData 搜索列表
                } else {
                    this.listData = []
                    this.showNoData = true
                    this.noticeText = noticeTextArr[0]
                }
            } catch (err) {
                console.log(err && err.msg)
            } finally {
                this.isShowLoading = false
            }
        },
        /**
         * @description:数量减 埋点
         * @param: {}
         * @param: {}
         * @return:
         */
        minusReport (item) {
            if (item.scanText) {
                window.webSdk.track('ds_del_scan_res', {
                    organSign: getCookie('native_organSign'),
                    barCode: item.scanText,
                    pref: item.pref || 0
                })
            }
        },
        overlimit () {
            return this.$toast({
                message: '药品数量最小为1'
            })
        },
        minus (item, index) {
            // debugger
            const sign = this.medicineArr.findIndex(el => {
                return el.pref === item.pref
            })
            if (this.medicineArr[sign].num > 0) {
                --this.medicineArr[sign].num

                const k = this.medicineArr[sign].productPref ? 'productPref' : 'pref'
                if (this.listData.length > 0) {
                    this.listData.map(i => {
                        if (i.pref === this.medicineArr[sign][k]) {
                            i.num = this.medicineArr[sign].num
                        }
                    })
                }
                if (this.medicineArr[sign].num === 0) {
                    this.minusReport(this.medicineArr[sign])
                    //   this.deleteDiagnoseByMedicine(
                    //     this.medicineArr[sign].pref || this.medicineArr[sign].productPref
                    //   )
                    this.$emit(
                        'perfOfDeleteMedicine',
                        this.medicineArr[sign].pref || this.medicineArr[sign].productPref
                    )
                    this.medicineArr.splice(sign, 1)
                }
            }
            this.handleData()
        },
        plus (item, index, type) {
            // 判断是否已经添加当前药品
            const el = this.medicineArr.findIndex(e => {
                const itemParams = item.pref ? 'pref' : 'productPref'
                const arrParams = e.pref ? 'pref' : 'productPref'
                return e[arrParams] == item[itemParams]
            })
            if (el === -1 && arguments.length === 1 && this.medicineArr.length > 4) {
                this.$toast({
                    message: '最多添加5种药品'
                })
                return false
            }
            if (el === -1) {
                this.medicineArr.push(item)
                const len = this.medicineArr.length - 1
                ++this.medicineArr[len].num
                console.log(item,this.medicineArr[len])
        // 二级搜索点击埋点
        window.webSdk.track('search_click', {
          organSign: getCookie('native_organSign'),
          keyWord: this.searchVal,
          resultNum: this.listData.length,
          select: item.commonName,
          seq: index
        })
      } else {
        ++this.medicineArr[el].num
      }
      this.handleData()
    },
    handleData() {
      // 购物车和搜索结果数据互通
      this.medicineArr.map(medicine => {
        const k = medicine.productPref ? 'productPref' : 'pref'
        this.listData.map(item => {
          if (item.pref === medicine[k]) {
            item.num = medicine.num
          }
        })
      })
    },
    /**
     * @description: 替换搜索关键字为红字
     * @param {string, string} oraignString - 要匹配的字符串， searchVal - 匹配关键字
     * @return: string 返回匹配后的完整的字符串
     */
    onReplaceFont(oriStr, searchVal, type) {
      // 匹配姓名，没有大小写问题
      if (type === 'username') {
        let reg = new RegExp(searchVal, 'g')
        let replaceHtml = '<font style="color:#01B956">' + searchVal + '</font>'
        return oriStr.replace(reg, replaceHtml)
      }

            const firstStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.slice(
                        0,
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase())
                    )
                    : ''
            const secondStr = `<span
        style="color:#01B956"
      >
        ${oriStr.slice(
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()),
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                searchVal.length
            )}
      </span>`
            const thirdStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.substr(
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                        searchVal.length
                    )
                    : oriStr
            return firstStr + secondStr + thirdStr
        },
        //海典自动填充  ----
        haiDianAutoWriteFun(item){
            this.searchVal = item.commonName;
            this.handClickLabel(this.searchVal, null, 'secSearch');
        },
        async handClickLabel (name, index, type) {
            this.isClickLabel = true
            this.isShowLoading = true
            try {
                // 一级点击埋点
                if (index) {
                    window.webSdk.track('sug_search_click', {
                        organSign: getCookie('native_organSign'),
                        resultNum: this.list.length,
                        select: name,
                        keyWord: this.searchVal,
                        seq: index
                    })
                }
                this.loading = true
                let params_name = name
                let searchValArr = this.searchVal.split(' ')
                if (searchValArr.length > 1 && type === 'secSearch') {
                    searchValArr[0] = name
                    params_name = searchValArr.join(' ')
                }
                const params = {
                    productName: params_name,
                    organSign: getCookie('native_organSign'),
                    productType: 0
                }
                const res = await drugsList2(params)
                this.list = []
                this.listData = res.data.result
                if (res.data.result.length === 0) {
                    this.noticeText = noticeTextArr[1]
                }
                //二级搜索埋点
                window.webSdk.track('search_page', {
                    organSign: getCookie('native_organSign'),
                    resultNum: this.listData.length,
                    keyWord: this.searchVal
                })
                // 这里遍历
                this.listData.map(item => {
                    this.$set(item, 'num', 0)
                })
                this.handleData()
                this.ifshow = false

                if (searchValArr.length > 1 && type === 'secSearch') {
                    searchValArr[0] = name
                    this.searchVal = searchValArr.join(' ')
                } else {
                    this.searchVal = name
                }
                this.isClickLabel = false
                this.isShowLoading = false
            } catch (err) {
                console.log(err.msg)
                this.isClickLabel = false
                this.isShowLoading = false
            }
        },
        fetchData (val, attr) {
            this.isShowLoading = true
            this.filterFlag = false
            this.pageNum = 1
            this.list = []
            this.listData = []
            this.finishedText = ''
            this.finished = false
            this.isKeydown = false
            this.showNoData = false
            if (val == '') {
                this.ifshow = false
                this.listData = []
                this.list = []
                this.isShowLoading = false
                return false
            } else {
                clearTimeout(this.iTime)
                this.iTime = setTimeout(() => {
                    //需要执行的事件
                    const keyWordArr = val.split(' ')
                    this.getTypeDate(keyWordArr[0], attr)
                }, 1000)
            }
        },
        async getTypeDate (val, attr) {
            try {
                this.loading = true
                const params = {
                    productName: val,
                    organSign: getCookie('native_organSign'),
                    attributeSpecification: attr,
                    productType: 0
                }
                const flag = this.queryMedicineListNum
                const res = await queryMedicineList2(params)
                this.loading = false
                //解决异步导致的列表数据错误问题
                if (this.queryMedicineListNum - flag > 0) {
                    return false
                }
                this.queryMedicineListNum++
                if (res.data && res.data.result) {
                    window.webSdk.track('sug_search_page', {
                        organSign: getCookie('native_organSign'),
                        keyWord: this.searchVal,
                        resultNum: res.data.result.length
                    })
                    this.ifshow = true
                    const newslist = res.data.result || []
                    if (this.pageNum > 1) {
                        this.list = [...this.list, ...newslist]
                    } else if (this.searchVal) {
                        this.list = newslist
                    }
                    // 如果当前页数 = 总页数，则已经没有数据
                    if (!res.data.result) {
                        this.showNoData = true
                        this.finished = true
                        this.finishedText = '没有更多了'
                        this.noticeText = noticeTextArr[1]
                    }
                    this.isShowLoading = false
                }
            } catch (err) {
                this.isShowLoading = false
                console.log(err.msg)
            }
        },

        /**
         * @description:处理键盘事件
         * @param: {Object} ev 键盘事件对象
         * @return: this.handClickLabel(this.searchVal,null,null)
         */
        handleKeydown (ev) {
            if (ev.keyCode === 13 && this.searchVal) {
                this.isKeydown = true
                this.handClickLabel(this.searchVal, null, null)
            }
        },
        /**
         * @description:点击扫码
         * @param: {}
         * @param: {}
         * @return:
         */
        handleQrcode () {
            this.showNoData = false
            this.noticeText = noticeTextArr[0]
            this.searchVal = ''
            this.list = []
            window.location.href = 'protocol://action/handleQrCode'
            window.webSdk.track('ds_click_scan_button', {
                organSign: getCookie('native_organSign')
            })
        },
        async getUsageAndDosageWriteSwitch () {
            let res = await getUsageAndDosageWriteSwitch({ organSign: getCookie('native_organSign') });
            console.log(res);
            if (res.data.code == 0) {
                this.isShowUsage = res.data.result
            } else {
                this.isShowUsage = false;
            }
        },
        async getInquiryAreaAndDrugstoreConfigSwitch () {
            let res = await getInquiryAreaAndDrugstoreConfigSwitch({ organSign: getCookie('native_organSign') });
            console.log(res);
            if (res.data.code == 0) {
                this.isEditUsage = res.data.result.usageAndDosageTempShowSwitch
                this.usageAndDosageReviewSwitch = res.data.result.usageAndDosageReviewSwitch // 用法用量审查开关
            } else {
                this.isEditUsage = false;
            }
        },
        // 搜索列表确定----bug
        stepPageDialog () {
            // 审查开关关闭的情况  不展示 showUsageDialog弹窗
            if(!this.usageAndDosageReviewSwitch || this.medicineArr.length  == 0) {
                this.$emit('finishMedicine', this.medicineArr)
                return ; 
            }
            this.getPageConfigurationQueryRuleByDrug() ; //获取药品规则
        },
        // 用法用量确定----bug
        submitMedicine () {
            this.showUsageDialog = false;
            this.finishMedicine()
        },
        // 退出选购药品按钮确定键----bug
        finishMedicine () {
            //   if (this.medicineArr.length === 0) {
            //     return false
            //   }
            this.$emit('finishMedicine', this.medicineArr)
            //   this.step = 0
            //   this.getDiagnosisByMedicine()
        },
        async unitFun () {
            const res = await unitList()
            if (res) {
                this.unitData = res.data.data
            }
        },
        async methodFun () {
            getMethod().then(res => {
                this.methodData = res.data.data
            })
        },
        async doseFun () {
            getDose().then(res => {
                this.dosageData = res.data.data
            })
        },
        async rateListFun () {
            const res = await rateList()
            if (res) {
                this.usedrugData = res.data.data
            }
        },

    }
}
</script>

<style scoped lang="scss">
.usage_text {
    width: 30px;
    font-size: 12px;
    margin-top: 20px;
    margin-left: 5px;
    text-wrap: nowrap;
    text-overflow: ellipsis;
}
.usageForm {
    width: 100%;
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .one {
        span:nth-child(1) {
            font-size: 12px;
            color: red;
        }
        span:nth-child(2) {
            font-size: 14px;
        }
    }
    .two {
        span {
            font-size: 14px;
            color: rgba(153, 153, 153, 1);
        }
    }
}
#root {
    height: calc(100vh - 50px);
    padding-bottom: 50px !important;

    &.setHeight {
        padding-top: 0;
    }
}
.buy-medicine {
    position: fixed;
    left: 0;
    right: 0;
    top: 49px;
    bottom: 0;
    background: #fff;
}
.content {
    position: relative;
    height: 100%;
    overflow-y: auto;
}
.search-box {
    background: white;
    width: 100%;
    display: flex;
    position: fixed;
    z-index: 1000;
    height: 53px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    /deep/ .van-field__clear {
        margin-right: 40px !important;
    }
    .qrcode {
        height: 38px;
        color: #01b956;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 15px;
        span {
            font-size: 11px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
        }
        .patient-icon-qrcode,
        .patient-icon-qrcode::before {
            font-size: 24px;
        }
    }
    .form {
        width: 300px;
        height: 60px;
    }
    .form-pad {
        width: 87%;
    }
    .search-input {
        width: 100%;
        padding-right: 0px;
        height: 60px;
        overflow: hidden;
        /deep/ .van-field__control {
            font-size: 13px !important;
        }
    }
    .search-input-pad {
        width: 100%;
    }
    /deep/ .van-field__control {
        padding-right: 50px !important;
    }

    .search-btn {
        height: 100%;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #01b956;
        display: block;
        line-height: 34px;
        text-align: center;
        top: 13px;
        right: 0;
        background: rgba(1, 185, 86, 0.05) !important;
        border-radius: 17px;
        width: 58px;
        height: 34px;
    }
    .search-btn-pad {
        height: 100%;
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #333333;
        margin-right: 15px;
        display: flex;
        align-items: center;
    }
}
.search-tips-wrap {
    padding-top: 10px;
    margin-top: 2px;
    width: calc(100% - 30px);
    height: 34px;
    position: fixed;
    top: 92px;
    left: 15px;
    background: white;
    z-index: 9999;
    .search-tips {
        display: flex;
        align-items: center;
        margin: 0 auto;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #99664d;
        line-height: 34px;
        background: #fff7ef;
        border-radius: 4px;
        padding: 0 15px;
    }
}
.search-main {
    // height: calc(100% - 75px);
    background: #f7f7f7;
    .van-list {
        height: 100%;
    }
}
.search-list {
    background: white;
    padding-left: 30px;
    padding-right: 15px;
    height: calc(100vh - 230px);
    overflow-y: scroll;
    // padding-bottom: 65px;
    margin-top: 50px;
    padding-top: 35px;
    li {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        height: 40px;
        border-bottom: 1px solid #ededed;
        width: 100%;
        text-wrap: wrap;
        padding-top: 10px;
        padding-bottom: 10px;
    }
}
.search-list li.noli {
    border: none;
    margin-top: 50%;
    text-align: center;
    color: #999;
}
.search-end {
    padding-left: 15px;
    // padding-bottom: 80px;
    margin-top: 80px;
    // height: calc(100% - 70px);
    ul {
        padding-top: 9px;
    }
}
.nodata-wrap {
    // padding-right: 30px;
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    img {
        width: 160px;
        height: 130px;
    }
    p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 5px;
    }
}
.search-end li.goods {
    padding: 15px 0;
    display: flex;
    position: relative;
    // height: 46px;
    .goods-left {
        width: 200px;
        height: 100%;
        p {
            margin: 0;
            padding: 0;
        }
        .goods-name {
            line-height: 24px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            span {
                display: block;
                box-sizing: border-box;
                padding: 0 5px;
                height: 18px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(239, 77, 77, 1);
                line-height: 18px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(239, 77, 77, 1);
                text-align: center;
                margin-right: 6px;
            }
            .goodsName {
                font-size: 14px !important;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                display: block;
            }
        }
        .specifications {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            margin: 5px 0 10px 0;
        }
        .producingArea {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .stepper {
        position: absolute;
        right: 20px;
        bottom: 24px;
    }
}
.add {
    position: absolute;
    right: 20px;
    // bottom: 24px;
    border-radius: 50%;
}
.cart-goods {
    padding-left: 15px;
    height: calc(100vh - 230px);
    overflow-y: scroll;
    // margin-bottom: 30px;
    &::-webkit-scrollbar {
        display: none;
    }
}
.cart-goods-two {
    padding-left: 15px;
    height: calc(100vh - 355px) !important;
    overflow-y: scroll;
    // margin-bottom: 30px;
    &::-webkit-scrollbar {
        display: none;
    }
}
.cart-goods li.goods {
    padding: 15px 0;
    display: flex;
    position: relative;
    .goods-left {
        width: 220px;
        height: 100%;
        p {
            margin: 0;
            padding: 0;
        }
        .goods-name {
            line-height: 24px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            span {
                display: inline-block;
                box-sizing: border-box;
                padding: 0 5px;
                height: 18px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(239, 77, 77, 1);
                line-height: 18px;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(239, 77, 77, 1);
                text-align: center;
                margin-right: 6px;
            }
            .goodsName {
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                display: block;
            }
        }
        .specifications {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            margin: 5px 0 10px 0;
        }
        .producingArea {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .stepper {
        position: absolute;
        right: 20px;
        bottom: 42px;
    }
}
.bottom-bar {
    background: white;
    z-index: 99;
    position: fixed;
    bottom: 0px;
    left: 0;
    display: flex;
    padding: 12px 15px 12px 24px;
    width: calc(100% - 39px);
    justify-content: space-between;
    align-items: center;
}
.disabled {
    background: rgba(200, 200, 200, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid #c8c8c8;
}
.van-popup {
    width: 100%;
    .box {
        padding: 30px 15px 0 15px;
        width: calc(100% - 30px);

        .box-top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            .box-title {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 28px;
            }
            img {
                width: 18px;
                height: 18px;
            }
        }
    }
}
.closeMedicinePup {
    margin-bottom: 20px;
}
.hot-medicine {
    padding-left: 15px;
    height: calc(100% - 165px);
    overflow: auto;
    margin-top: 95px;
    & li {
        display: flex;
    }
    .top-title {
        margin: 0;
        color: #333333;
        font-size: 15px;
    }
    &-rank_img {
        width: 19px;
        height: 19px;
        margin-top: 15px;
    }
    &-item {
        padding: 15px 0 15px 10px;
        width: calc(100% - 19px);
        position: relative;
    }
    &-item_top {
        display: flex;
        align-items: center;
    }
    &-item_rx {
        font-size: 10px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #ef4d4d;
        height: 16px;
        background: #ffffff;
        border: 1px solid #ef4d4d;
        border-radius: 4px;
        padding: 0 6px;
    }
    &-item_name {
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        width: 200px;
        margin-left: 6px;
        line-height: 21px;
    }
    &-item_bottom {
        width: 200px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        margin-top: 6px;
        line-height: 17px;
    }
    &-item_add {
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #01b956;
        line-height: 22px;
        position: absolute;
        right: 15px;
        top: 26px;
    }
    &-item_producingArea {
        width: 200px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        margin-top: 6px;
        line-height: 17px;
    }
}
.cart-goods /deep/ {
    .van-stepper__minus,
    .van-stepper__plus {
        border-radius: 50%;
        border: 1px solid #01b956;
    }
    .van-stepper__minus {
        background: white;
    }
    .van-stepper__plus {
        background: #01b956;
    }
    .van-stepper__minus--disabled,
    .van-stepper__plus--disabled {
        color: #01b956;
        width: 28px;
        height: 28px;
    }
    .van-stepper__input {
        background: white;
        font-weight: 500;
    }
    .van-stepper__minus::after,
    .van-stepper__minus::before {
        background-color: #01b956;
    }
    .van-stepper__plus::after,
    .van-stepper__plus::before {
        background-color: white;
    }
    .van-icon-add:before {
        color: #01b956;
        width: 28px;
        height: 28px;
    }
    .van-stepper__input:disabled {
        background-color: inherit;
        opacity: 1;
        color: inherit;
        -webkit-text-fill-color: inherit;
    }
    .van-icon-search:before {
        color: #7b7b7b;
    }
    .van-icon-arrow-left:before {
        color: #666;
    }
}
</style>
